module.exports = __webpack_public_path__ + "static/media/c21-connect.3715973d.png";